// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3LVF7","notes":"Notes_notes__un4rG"};